export const voiceTypes = [
  'voice',
  'voice-external-did',
  'voice-internal-did',
  'voice-external-queue',
  'voice-internal-queue',
];

export const isVoiceTask = (type: string) => {
  const isVoice = voiceTypes.includes(type);
  return isVoice;
};
